export default __webpack_public_path__ + "static/media/03.af5fa140.webp";